<template>
  <div class="grid-view__cell">
    <div class="grid-field-text">
      <SearchHighlightedText :text="value" :search-term="searchTerm" />
    </div>
  </div>
</template>

<script>
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  name: 'FunctionalGridViewFieldText',
  components: { SearchHighlightedText },
  props: {
    value: {
      type: String,
      default: '',
    },
    searchTerm: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>
